import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MaterializeAction} from "angular2-materialize";
import { VehiclePartAnalog } from '../../../model/vehicle-part-analog';

@Component({
  selector: 'tx-monitoring-file',
  templateUrl: './monitoring-file.component.html',
  styleUrls: ['./monitoring-file.component.css']
})
export class MonitoringFileComponent implements OnInit {

  _file: any;
  _description: string;
  _viewMode: boolean;
  _vehiclePart: any;
  accepted: boolean;
  rejected: boolean;
  validType: boolean;

  @Output() txOnAccept: EventEmitter<void> = new EventEmitter();
  @Output() txOnReject: EventEmitter<void> = new EventEmitter();
  @Output() txOnRequestModelImage: EventEmitter<void> = new EventEmitter();
  modalActions = new EventEmitter<string|MaterializeAction>();

  constructor() {
  }

  ngOnInit() {
  }

  @Input()
  set file(file) {
    this._file = file;
    if (this._file.accepted) {
      this.accepted = true;
      this.rejected = false;
    }
    this.validType = this._file.vehiclePart !== 'OTHER';
  }

  get file() {
    return this._file;
  }

  @Input()
  set viewMode(viewMode) {
    this._viewMode = viewMode;
  }

  get viewMode() {
    return this._viewMode;
  }

  @Input()
  set description(description) {
    this._description = description;
  }

  get description() {
    return this._description;
  }

  @Input()
  set vehiclePart(vehiclePart) {
    this._vehiclePart = vehiclePart;
  }

  get vehiclePart() {
    return this._vehiclePart;
  }

  accept() {
    this.accepted = !this.accepted;
    this.rejected = false;
    this.txOnAccept.emit(this._file);
  }

  reject() {
    this.modalActions.emit({ action: 'modal', params: ['open'] });
  }

  emitRejection() {
    this.rejected = !this.rejected;
    this.accepted = false;
    this.txOnReject.emit(this._file);
  }

  requestModelImage() {
    this.txOnRequestModelImage.emit(this._file);
  }

  showEmptyState() {
    return this._file === null || !this._file.id;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/monitoring/monitoring-file/monitoring-file.component.ts